module.exports = __webpack_public_path__ + "static/media/showOff.cc0ab50a.svg";